import { render, staticRenderFns } from "./BlockTxRowMobile.vue?vue&type=template&id=34e01d08&functional=true"
import script from "./BlockTxRowMobile.vue?vue&type=script&lang=js"
export * from "./BlockTxRowMobile.vue?vue&type=script&lang=js"
import style0 from "./BlockTxRowMobile.vue?vue&type=style&index=0&id=34e01d08&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports